import React, { useContext, useEffect, useState } from 'react'
import Loading from '../loading/Loading'
import AccountListItem from './AccountListItem'
import RoleContext, { USER_ROLE } from '../signin/RoleContext'
import { Link, Redirect } from 'react-router-dom'
import Auth from '../services/Auth'
import AccountInfo from "../viewModels/AccountInfo"
import { Routes } from '../App'
import LPContext, { DEFAULT_LP } from '../lpLoader/LPContext'
import CallToken from '../settings/CallToken'

const AccountList = () => {
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [accounts, setAccounts] = useState<AccountInfo[]>([])
  const lpContext = useContext(LPContext);
  const roleContext = useContext(RoleContext);
  const accountLineItems: JSX.Element[] = [];

  const deleteUser = async (deleteId: number) => {
    setLoading(true);

    await Auth.deleteUser(deleteId).then((response: string) => {
      if (!response || response.startsWith("Could not delete")) {
        alert(response);
        setLoading(false);
      } else {
        loadAccounts();
        alert('Successfully deleted user');
      }
    });
  }

  accounts.forEach((item, index) => {
    accountLineItems.push(
      <AccountListItem
        account={item}
        key={index}
        userRoles={roleContext.roles}
        onDelete={deleteUser}
      />,
    )
  });

  const doLoadAccounts = () => {
    loadAccounts();
  }
  const loadAccounts = async () => {
    if (!lpContext.LP?.id ) {
      setErrorMsg('Select LP');
      return
    }

    setLoading(true)
    setErrorMsg('')

    const response = await Auth.getAccountListing(lpContext.LP.id)

    setLoading(false)
    if (response.is_error) {
      setErrorMsg(response.error_content)
    } else {
      const lineItems = []
      for (let i = 0; i < response.content.value.length; i++) {
        lineItems.push(response.content.value[i])
      }

      setAccounts(lineItems)
    }
  }

  useEffect(doLoadAccounts, [lpContext.LP])

  if (!Auth.checkRoleMembership([USER_ROLE.ADMIN, USER_ROLE.MANAGEUSERS])) {
    return <Redirect to={ Routes.Home } />;
  }

  return (
    <div>
      <CallToken />
      <div className="row" style={{ margin: '10px 0' }}>
        <div>
          <h1>
            Manage Accounts
            {lpContext.LP.id !== DEFAULT_LP.id
              ? ` - ${lpContext.LP.id}`
              : ' - All LPs'}
          </h1>
        </div>
        <div className="col-md">
          <div className="float-right">
            <Link to={`/account/create/${lpContext.LP.id}`}>
              <button className="btn btn-orange">+ Create User</button>
            </Link>
          </div>
        </div>
      </div>
      <Loading show={loading} />
      {errorMsg && !loading && (
        <div className="text-danger">{`An Error Occurred: ${errorMsg}`}</div>
      )}

      {!loading && !errorMsg &&
        <>
          <div className="table">
            <div className="table-header" key="-1">
              <div>Name</div>
              <div>Email</div>
              <div>Phone</div>
              <div>Actions</div>
            </div>
            {accountLineItems}
          </div>
        </>
      }
    </div>
  )
}

export default AccountList;
